<template>
  <main id="utilTemplet">
    <section id="content">
      <div class="inner">
        <article class="utilForm login">
          <p class="subTxt">이천시 통합주차정보시스템</p>
          <h2>LOGIN</h2>
          <div class="inputArea">
            <input type="text" placeholder="아이디" title="아이디" v-model="empNo" />
            <input type="password" placeholder="비밀번호" title="비밀번호" v-model="password" @keyup.enter="login" />
          </div>
          <div class="findArea">
            <button class="txt" @click="IdFind">아이디 찾기</button>
            <button class="txt" @click="PwFind">비밀번호 찾기</button>
          </div>
          <div class="btnArea">
            <button type="button" class="btn blue" @click="login">로그인</button>
          </div>
          <button class="txt" @click="$router.push('/join')">아직 회원이 아니신가요?</button>
        </article>
      </div>
    </section>

    <!-- 아이디 찾기 -->
    <find-id v-if="idShow">
      <template #info> 아이디 찾기 </template>
      <template #content>
        <article class="paragraph">
          <p>가입자 이름과 휴대폰 번호를 입력해주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                아이디 찾기
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td>
                    <input type="text" title="법인(단체명) 입력" v-model="name" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰 번호</th>
                  <td>
                    <div class="tell">
                      <input
                        type="text"
                        id="firstNumber"
                        placeholder="010"
                        v-model="firstNumber"
                        maxlength="3"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        id="secondNumber"
                        v-model="secondNumber"
                        maxlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        id="lastNumber"
                        v-model="lastNumber"
                        maxlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn blue" @click="findUserId">아이디 찾기</button>
        </article>
        <article>
          <div v-if="searchId" class="match">
            <p>고객님의 정보와 일치하는 아이디 정보입니다.</p>
            <div class="skyBox">
              <strong>{{ userId }}</strong>
            </div>
            <article class="btnArea">
              <button class="btn blue" @click="CloseBtn">확인</button>
            </article>
          </div>
          <div v-if="notMatchId" class="not-match">
            <div class="skyBox">
              <p>입력하신 정보와 일치하는 아이디 정보가 존재하지 않습니다.</p>
              <p>다시 한번 정확히 입력해 주세요.</p>
            </div>
            <article class="btnArea">
              <button class="btn border" @click="CloseBtn">닫기</button>
            </article>
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </find-id>

    <!-- 패스워드 찾기 -->
    <find-pw v-if="pwShow">
      <template #info> 비밀번호 찾기 </template>
      <template #content>
        <article class="paragraph">
          <p>가입하신 아이디와 휴대폰 번호를 입력해주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                비밀번호 찾기
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">아이디</th>
                  <td>
                    <input type="text" title="아이디 입력" v-model="namePW" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰 번호</th>
                  <td>
                    <div class="tell">
                      <input
                        type="text"
                        id="firstNumberPW"
                        placeholder="010"
                        v-model="firstNumberPW"
                        maxlength="3"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        id="secondNumberPw"
                        placeholder="1234"
                        v-model="secondNumberPW"
                        maxlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        id="lastNumberPw"
                        placeholder="5678"
                        v-model="lastNumberPW"
                        maxlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn blue" @click="smsBtn">인증번호 발송</button>
        </article>
        <article v-show="sendMessage">
          <div class="table pop-table">
            <table>
              <caption>
                패스워드 찿기 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">인증번호</th>
                  <td>
                    <div class="flex timeInput">
                      <div class="timer">
                        <input type="text" placeholder="인증번호 5자리" title="인증번호 입력" v-model="inputPinNo" />
                        <span class="time">{{ timer }}</span>
                      </div>
                      <button class="btn border" @click="plusTime()">시간연장</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <article class="btnArea">
            <button class="btn blue" @click="ChangePwBtn">확인</button>
          </article>
          <article class="paragraph notice">
            <p>인증번호 문자를 못 받으셨나요?</p>
            <p>인증번호가 문자로 수신되지 않을 경우 정확한 정보로 재시도해 주시기 바랍니다.</p>
          </article>
        </article>
        <article>
          <div v-if="notMatchCertNo" class="not-match">
            <div class="skyBox">
              <p>인증번호가 일치하지 않습니다.</p>
              <p>다시 한번 정확히 입력해 주세요.</p>
            </div>
          </div>
          <article class="btnArea">
            <button class="btn border" @click="CloseBtn">닫기</button>
          </article>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </find-pw>

    <!-- 패스워드 변경 -->
    <change-pw v-show="changeShow">
      <template #info>
        <li>비밀번호 변경</li>
      </template>
      <template #content>
        <article class="paragraph">
          <p>변경하실 비밀번호를 입력 해 주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                비밀번호 변경 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">비밀번호</th>
                  <td>
                    <input
                      type="password"
                      title="비밀번호 입력"
                      placeholder="영문,숫자,특수문자 조합 8-20자리"
                      v-model="changePwd"
                    />
                    <div class="error" v-if="!$v.changePwd.required">필수 입력란입니다.</div>
                    <div class="error" v-else-if="!$v.changePwd.minLength || !$v.changePwd.maxLength">
                      8~20자리 입력란입니다.
                    </div>
                    <div class="error" v-if="!$v.changePwd.passRegex">
                      조건에 맞지 않습니다. <br />※ 숫자,영문자,특수문자 (8~20자리)
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input type="password" title="비밀번호 재입력" v-model="changePwdCk" />
                    <div class="error" v-if="!$v.changePwdCk.required">필수 입력란입니다.</div>
                    <div class="error" v-else-if="!$v.changePwdCk.sameAsPassword">일치하지 않는 비밀번호입니다.</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn blue" @click="ChangeBtn">확인</button>
        </article>
        <article>
          <div v-if="notMatchPw" class="not-match">
            <div class="skyBox">
              <p>비밀번호가 일치하지 않습니다.</p>
              <p>다시 한번 정확히 입력해 주세요.</p>
            </div>
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </change-pw>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import findId from '../../../components/PopupType1.vue';
import findPw from '../../../components/PopupType1.vue';
import changePw from '../../../components/PopupType1.vue';
import { required, minLength, maxLength, helpers, sameAs } from 'vuelidate/lib/validators';
import dayjs from 'dayjs';
const mobileRegex = helpers.regex('mobileRegex', /\d$/);
const passRegex = helpers.regex('passRegex', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);

export default {
  data() {
    return {
      empNo: '',
      password: '',
      idShow: false,
      pwShow: false,
      changeShow: false,
      searchId: false,
      showId: false,
      sendMessage: false,
      notMatchId: false,
      noId: false,
      notMatchCertNo: false,
      notMatchPw: false,

      userId: '',
      name: '',
      firstNumber: '',
      secondNumber: '',
      lastNumber: '',
      namePW: '',
      firstNumberPW: '',
      secondNumberPW: '',
      lastNumberPW: '',
      inputPinNo: '',
      changePwd: '',
      changePwdCk: '',

      pinNo: '',
      timer: '',
      timeCounter: '',
      timerStr: '',
      timeInterval: '',
    };
  },

  components: {
    findId,
    findPw,
    changePw,
  },

  validations: {
    empNo: {
      required,
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
    },
    firstNumber: {
      required,
      mobileRegex,
      minLength: minLength(3),
    },
    secondNumber: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
    lastNumber: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
    name: {
      required,
    },
    firstNumberPW: {
      required,
      mobileRegex,
      minLength: minLength(3),
    },
    secondNumberPW: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
    lastNumberPW: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
    namePW: {
      required,
    },
    changePwd: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      passRegex: passRegex,
    },
    changePwdCk: {
      required,
      sameAsPassword: sameAs('changePwd'),
    },
  },

  methods: {
    IdFind() {
      this.clearFindId();
      this.idShow = true;
    },

    PwFind() {
      this.clearFindPw();
      this.sendMessage = false;
      this.pwShow = true;
    },

    CancleBtn() {
      this.idShow = false;
      this.pwShow = false;
      this.searchId = false;
      this.notMatchId = false;
    },

    CloseBtn() {
      this.idShow = false;
      this.pwShow = false;
      this.changeShow = false;
      this.sendMessage = false;
      this.notMatchId = false;
      this.notMatchPw = false;
      this.searchId = false;
      this.timerStop(this.timeInterval);
    },

    emitChangeModal() {
      this.idShow = false;
      this.pwShow = false;
      this.changeShow = false;
      this.sendMessage = false;
      this.timerStop(this.timeInterval);
    },

    clearFindId() {
      this.name = '';
      this.firstNumber = '';
      this.secondNumber = '';
      this.lastNumber = '';
    },

    clearFindPw() {
      this.namePW = '';
      this.firstNumberPW = '';
      this.secondNumberPW = '';
      this.lastNumberPW = '';
      this.inputPinNo = '';
      this.changePwd = '';
      this.changePwdCk = '';
    },

    async findUserId() {
      if (
        this.$v.name.$invalid ||
        this.$v.firstNumber.$invalid ||
        this.$v.secondNumber.$invalid ||
        this.$v.lastNumber.$invalid
      ) {
        this.notMatchId = true;
        return;
      }

      let apiParams = new FormData();
      apiParams.append('empNm', this.name);
      apiParams.append('empMobile', this.firstNumber + this.secondNumber + this.lastNumber);

      const response = await axios('post', '/api/member/findId.json', apiParams);

      const data = response.data;
      if (data.message !== 'true') {
        this.searchId = false;
        this.notMatchId = true;
        return;
      }
      this.searchId = true;
      this.userId = data.empNo;
      this.notMatchId = false;
    },

    loginValidate() {
      if (!this.$v.empNo.required) {
        alert('아이디를 입력하여주십시오.');
        return false;
      } else if (!this.$v.password.required) {
        alert('비밀번호를 입력하여주십시오.');
        return false;
      } else if (!this.$v.password.minLength || !this.$v.password.maxLength) {
        alert('비밀번호는 8~20 사이의 자리여야 합니다.');
        return false;
      } else {
        return true;
      }
    },

    async login() {
      if (!this.loginValidate()) return;
      const response = await axios('post', '/api/actionLogin.json', null, {
        params: {
          empNo: this.empNo,
          password: this.password,
        },
      });
      const data = response.data;
      if (!data.result) {
        alert(data.msg);
        return;
      }
      const sessionId = data.attributeMap.SPRING_SECURITY_CONTEXT.authentication.details.sessionId;
      const authorCode = data.attributeMap.loginVO.authorCode;
      const empNo = data.attributeMap.loginVO.empNo;
      const empNm = data.attributeMap.loginVO.empNm;
      const empMobile = data.attributeMap.loginVO.empMobile;
      const empCarNo = data.attributeMap.loginVO.empCarNo;
      const zipcode = data.attributeMap.loginVO.zipcode;
      const addr = data.attributeMap.loginVO.address;
      const addrDetail = data.attributeMap.loginVO.addressDetail;
      const empDiv = data.attributeMap.loginVO.empDiv;
      const marketYn = data.attributeMap.loginVO.marketYn;
      const empEsntlId = data.attributeMap.loginVO.empEsntlId;

      if (sessionId !== undefined && sessionId !== '') {
        this.$store.dispatch('authorCode', authorCode);
        this.$store.dispatch('empNo', empNo);
        this.$store.dispatch('empNm', empNm);
        this.$store.dispatch('empMobile', empMobile);
        this.$store.dispatch('empCarNo', empCarNo);
        this.$store.dispatch('zipcode', zipcode);
        this.$store.dispatch('addr', addr);
        this.$store.dispatch('addrDetail', addrDetail);
        this.$store.dispatch('empDiv', empDiv);
        this.$store.dispatch('isLogin', true);
        this.$store.dispatch('marketYn', marketYn);
        this.$store.dispatch('empEsntlId', empEsntlId);
        alert(data.msg);
        if (authorCode == 'ROLE_STORE' || authorCode == 'ROLE_ADMIN') {
          this.$router.push('/webdiscountuse');
        } else {
          this.$router.push('/main');
        }
      }
    },

    async smsBtn() {
      if (
        this.$v.namePW.$invalid ||
        this.$v.firstNumberPW.$invalid ||
        this.$v.secondNumberPW.$invalid ||
        this.$v.lastNumberPW.$invalid
      ) {
        this.sendMessage = false;
        alert('아이디, 핸드폰번호를 다시 확인해주세요.');
        return;
      }
      let apiParams = new FormData();
      apiParams.append('empNo', this.namePW);
      apiParams.append('empMobile', this.firstNumberPW + this.secondNumberPW + this.lastNumberPW);
      const res = await axios('post', '/api/member/checkId.json', apiParams);
      const data = res.data.result;
      if (!data) {
        alert('아이디를 다시 확인해주세요.');
        return;
      }

      this.sendMessage = true;
      this.timerStop(this.timeInterval);
      this.timerStart();
      await axios('get', '/api/member/send.json', {
        rcvAddr: this.firstNumberPW + this.secondNumberPW + this.lastNumberPW,
      });

      // 임시 콘솔
    },

    timerStart() {
      this.timeCounter = 180;
      this.timer = this.prettyTime();
      this.timeInterval = setInterval(() => {
        this.timeCounter--;
        this.timer = this.prettyTime();
        if (this.timeCounter <= 0) {
          alert('인증 시간이 만료되었습니다.');
          this.sendMessage = false;
          this.clearFindPw();
          this.timerStop(this.timeInterval);
        }
      }, 1000);
    },

    timerStop(timeInterval) {
      clearInterval(timeInterval);
      this.timeCounter = 0;
    },

    prettyTime() {
      const time = this.timeCounter / 60;
      const minutes = parseInt(time);
      const seconds = Math.round((time - minutes) * 60);
      return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    },

    plusTime() {
      this.timerStop(this.timeInterval);
      this.timer = '';
      this.timerStart();
    },

    async ChangePwBtn() {
      const apiParams = new FormData();
      apiParams.append('pinNo', this.inputPinNo);
      const res = await axios('post', '/api/member/pinNoChk.json', apiParams);
      if (res.data.result != btoa(this.inputPinNo + dayjs(new Date()).format('YYYYMMDD')) || !res.data.result) {
        this.notMatchCertNo = true;
        return;
      }
      this.pwShow = false;
      this.changeShow = true;
      this.namePW = this.namePW;
      this.sendMessage = false;
      this.timerStop(this.timeInterval);
    },

    async ChangeBtn() {
      if (this.$v.namePW.$invalid || this.$v.changePwd.$invalid || this.$v.changePwdCk.$invalid) {
        this.notMatchPw = true;
        return;
      }
      let apiParams = new FormData();
      apiParams.append('id', this.namePW);
      apiParams.append('pw', this.changePwd);
      const response = await axios('post', '/api/member/changePw.json', apiParams);
      const data = response.data.result;

      if (data != true) {
        alert('비밀번호 변경에 실패하였습니다. 다시 시도해주세요.');
        return;
      }
      this.changeShow = false;
      alert('비밀번호 변경이 완료되었습니다.');

      this.idShow = false;
    },
  },
};
</script>
